// src/routes/AppRoutes.js
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import HomePage from '../pages/HomePage'; // Page marketing
import LoginPage from '../pages/LoginPage';
import AppHomePage from '../pages/AppHomePage.js'; // Page d'accueil après connexion
import ProcessPage from '../pages/ProcessPage';
import SettingsPage from '../pages/SettingsPage';
import ConfigPage from '../pages/ConfigPage';
import ManagementPage from '../pages/ManagementPage';
import SupportPage from '../pages/SupportPage';
import MatchingPage from '../pages/MatchingPage';
import AnalysePage from '../pages/AnalysePage';
import DemoPage from '../pages/DemoPage';
import FichePostePage from '../pages/FichePostePage';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import ResetPasswordPage from '../pages/ResetPasswordPage.js';
import JobSearchPage from '../pages/JobSearchPage';
import JobDetailsPage from '../pages/JobDetailsPage';
// ── NOUVEAU : pages légales dédiées ──
import LegalPage from '../pages/LegalPage';

const AppRoutes = () => (
  <Router>
    <Routes>
      {/* Routes Publiques */}
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/demo" element={<DemoPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      {/* ── NOUVEAU : documents légaux ── */}
      <Route path="/mentions-legales" element={<LegalPage doc="mentions" />} />
      <Route path="/cgu"             element={<LegalPage doc="cgu" />} />

      {/* Routes Protégées avec une mise en page commune (Navbar, Footer) */}
      <Route element={<Layout />}>
          <Route path="/home" element={<AppHomePage />} />

          {/* --- ROUTES PROTÉGÉES PAR MODULE --- */}

          {/* Générateur */}
          <Route element={<ProtectedRoute moduleKey="generator" />}>
             <Route path="/process" element={<ProcessPage />} />
          </Route>

          {/* Matching */}
          <Route element={<ProtectedRoute moduleKey="matching" />}>
             <Route path="/matching" element={<MatchingPage />} />
          </Route>

          {/* Audit CV */}
          <Route element={<ProtectedRoute moduleKey="audit_cv" />}>
             <Route path="/analyse" element={<AnalysePage />} />
          </Route>

          {/* Fiche de Poste */}
          <Route element={<ProtectedRoute moduleKey="fiche_poste" />}>
             <Route path="/fiche-poste" element={<FichePostePage />} />
          </Route>

          <Route element={<ProtectedRoute moduleKey="job_search" />}>
             <Route path="/job-search" element={<JobSearchPage />} />
             <Route path="/job-search/:id" element={<JobDetailsPage />} />
          </Route>

          {/* Configuration et autres pages communes */}
          <Route path="/settings/templates" element={<SettingsPage />} />
          <Route path="/settings/boondmanager" element={<ConfigPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/management" element={<ManagementPage />} />

      </Route>

      {/* Gérer les pages non trouvées */}
      <Route path="*" element={<h1>404 Not Found</h1>} />
    </Routes>
  </Router>
);

export default AppRoutes;